module.exports = __webpack_public_path__ + "static/media/subOutlook2.8c0a1f58.png";